import { Table } from "antd";
import React from "react";

import { Link, useNavigate } from "react-router-dom";
import CustomCard from "../../../../dentail-indetifcation/components/d-reusable/CustomCard";
import CustomPrimaryButton from "../../../../dentail-indetifcation/components/d-reusable/CustomPrimaryButton";
import {
  ageAssessmentBasePath,
  formateDateAndTime,
  renderCaseStatusTextAndBgColor,
  renderProjectStatusTextAndBgColor,
} from "../../../../helper";
import { assessmentIcons } from "../../../utils/assessmentIcons";

const RecentCases = ({ data }) => {
  const navigate = useNavigate();

  const handleOpenSingleCaseDetail = (record) => {
    navigate(`${ageAssessmentBasePath}/cases/details`, {
      state: { projectId: record.id },
    });
  };

  return (
    <CustomCard>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "20px 10px",
        }}
      >
        <h6
          style={{
            padding: 0,
            margin: 0,
            fontSize: 18,
            fontFamily: "Poppins-Medium",
          }}
        >
          Recent Cases
        </h6>
        <CustomPrimaryButton
          title={"View All"}
          onClick={() => navigate(`${ageAssessmentBasePath}/cases`)}
        />
      </div>
      <Table
        dataSource={data}
        style={{ overflowX: "scroll" }}
        pagination={false}
        columns={[
          {
            title: "Case Number",
            key: "case_number",
            render: (text, record) => {
              return (
                <div style={{ display: "flex", gap: 20, alignItems: "center" }}>
                  <img src={assessmentIcons.caseNumberIcon} />
                  <div className="custom_table_row_data">
                    <p className="_id">{record?.case_number}</p>
                  </div>
                </div>
              );
            },
          },
          {
            title: "Name",
            key: "name",
            dataIndex: "name",
          },

          {
            title: "Gender",
            dataIndex: "gender",
            key: "gender",
          },
          {
            title: "Registration Date",
            key: "created_at",
            render: (text, record) =>
              formateDateAndTime(record.created_at, "DD MMM YYYY"),
          },

          {
            title: <div className="custom_header_col">Status</div>,
            key: "status",
            render: (text, record) => {
              const bgColor = renderCaseStatusTextAndBgColor(record?.status);

              return (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div
                    style={{
                      background: bgColor,
                      padding: "1px 10px",
                      textAlign: "center",
                      borderRadius: 10,
                      color: "#FFFFFF",
                      textTransform: "capitalize",
                      fontSize: 12,
                      fontFamily: "Poppins-Regular",
                      fontWeight: "500",
                    }}
                  >
                    {record.status}
                  </div>
                </div>
              );
            },
          },

          {
            title: "Action",
            key: "action",
            align: "center",
            render: (t, record) => {
              return (
                <div
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#20C3FF",
                  }}
                  onClick={() => handleOpenSingleCaseDetail(record)}
                >
                  {/* <img
                      src={dentalIcons.viewIcon}
                      alt="Share"
                      style={{ cursor: "pointer", paddingRight: 4 }}
                    /> */}
                  View Details
                </div>
              );
            },
          },
        ]}
      />
    </CustomCard>
  );
};

export default RecentCases;
